/* 🤖 this file was generated by svg-to-ts */
export const iconWarningCross: {
  name: 'warning_cross';
  data: string;
} = {
  name: 'warning_cross',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><circle cx="12" cy="12" r="12" fill="#EE8B00"/><path fill="#FFF" d="M11.75 16c-.828 0-1.5-.598-1.5-1.337V5.337c0-.738.672-1.337 1.5-1.337s1.5.599 1.5 1.337v9.326c0 .74-.672 1.337-1.5 1.337m0 4a1.487 1.487 0 0 1-1.38-2.077c.075-.18.18-.344.315-.481a1.505 1.505 0 0 1 2.13 0c.135.137.24.3.315.481A1.487 1.487 0 0 1 11.75 20"/></g></svg>`,
};
